import { PostsOrPages } from '@tryghost/content-api'
import fetch from 'node-fetch'

export const getPosts = async ({
  limit,
  tagSlug,
}: {
  limit: number
  tagSlug: string
}): Promise<PostsOrPages | []> => {
  try {
    const url = new URL(
      `${
        process.env.GHOST_API_URL || 'https://ghost.noissue.co'
      }/ghost/api/v3/content/posts`
    )
    url.searchParams.append('key', process.env.CMS_GHOST_CONTENT_API_KEY || '')
    url.searchParams.append('limit', `${limit}`)
    url.searchParams.append('filter', `tag:${tagSlug}`)
    url.searchParams.append('order', 'published_at DESC')
    url.searchParams.append('include', 'tags,authors')

    const response = await fetch(url.toString())
    const data = await response.json()

    return data?.posts || []
  } catch (error) {
    console.error({ error, message: 'Error fetching Ghost posts:' })
    return []
  }
}
